import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import ArticleModalWithDatatable from '../article/ArticleModalWithDatatable';
import DocumentModalWithDatatable from '../document/DocumentModalWithDatatable';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import NumberFormat from 'react-number-format';
import CustomSelect from '../../components/custom-select/CustomSelect';
import * as RestService from '../../services/eisRest';
import moment from 'moment';
import 'moment/locale/sk';
import DatePicker, { registerLocale } from "react-datepicker";
import sk from 'date-fns/locale/sk';
import "react-datepicker/dist/react-datepicker.css";
registerLocale('sk', sk)




  const WorkOrderModal = (props) => {

   

    const [t] = useTranslation();      
    const {i18n} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [month, setMonth] = useState(null);  
    const [selectedRecord, setSelectedRecord] = useState();
    const [entityId, setEntityId] = useState();
    const [projectList, setProjectList] = useState([]);
    const [workOrderRequestTypeList, setWorkOrderRequestTypeList] = useState([]);
    const [workOrderStatusList, setWorkOrderStatusList] = useState([]);
    const [templateList, setTemplateList] = useState([]);
    
    const [workOrder, setWorkOrder] = useState(null);  
    const [openAlertDialog, setOpenAlertDialog] = useState(false);    
    const dialogRef = createRef();
    const [showArticleModalWithDatatable, setShowArticleModalWithDatatable] = useState(false);
    const [showDocumentModalWithDatatable, setShowDocumentModalWithDatatable] = useState(false);
    const [qtyOrd, setQtyOrd] = useState(0);
    const [orderLineId, setOrderLineId] = useState('');
   
    
    

    const [loadedArticle, setLoadedArticle] = useState(null);


    const [loadedDocument, setLoadedDocument] = useState(null);    
       
    const [dueDate, setDueDate] = useState(0);
    const [openDate, setOpenDate] = useState(null);
    const [closeDate, setCloseDate] = useState(null);
    

    const handleOpenArticleList = () => {
      setLoadedDocument(null);       
      formik.setFieldValue("orderName","");      
      formik.setFieldValue("orderLineNumber","");    
      setOrderLineId(null);
      setShowArticleModalWithDatatable(true);
    }

    const handleCallback = (show,id) => {         
      setShowArticleModalWithDatatable(show);             
      getDataAboutArticle(id);
    };
  
    const getDataAboutArticle = (id) => {
      RestService.callAnyApi('article/getArticle?id='+id, null)
      .then((data) => {
        setLoadedArticle(data);  
        
        formik.setFieldValue("articleName",data.name);
        
      })
      .catch((error) => {
        console.log(error);
      });
    }


    const handleOpenOrderList = () => {
      setShowDocumentModalWithDatatable(true);
    }

    const handleCallbackDocumentModalWithDatatable = (show,id,subRowId) => {         
      setShowDocumentModalWithDatatable(show);             
      getDataAboutDocument(id,subRowId);
    };
  
    const getDataAboutDocument = (id,subRowId) => {
      RestService.callAnyApi('document/getDocument?id='+id, null)
      .then((data) => {      
        //setLoadedArticle(null);  

        
              setLoadedDocument(data);      
              if(workOrder && workOrder.dueDate==null){
                setDueDate(data.documentDate2 ? data.documentDate2 : 0);
              } 

              if(data!=null && data.documentLines!=null){
                data.documentLines.map((line,index) => {
                  if(line.id===subRowId){
                    
                    //formik.setFieldValue("articleName",line.itemName);  
                    formik.setFieldValue("orderName",data.documentText1);      
                    formik.setFieldValue("orderLineNumber",line.lineNumber);
                    setQtyOrd(line.qty);
                    setOrderLineId(line.id);
                    getDataAboutArticle(line.itemId);   

                  }
                });
              }
        
              if(data.id==null){
                setLoadedDocument(null);               
              }          
        
      })
      .catch((error) => {
        console.log(error);
      });
    }


    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      if(loadedArticle!=null && loadedArticle.name!=null){        
        formik.setFieldValue("articleName",loadedArticle.name);
      }
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    
    useEffect(() => {
      if(loadedArticle!=null){
        RestService.callAnyApi('workOrder/getWrRouteTemplateOptions?articleId='+loadedArticle.id, null).then((data) => { setTemplateList(data);}).catch((error) => {});      
      }
    }, [loadedArticle]);

    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('workOrder/getWorkOrder?id='+props.selectedRecord, null)
      .then((data) => {          
           setWorkOrder(data);    
           
           getDataAboutDocument(data.orderId,data.orderLineId);
           getDataAboutArticle(data.articleId);    
           formik.setFieldValue("wrRouteTemplateId",data.wrRouteTemplateId);                                     
           setQtyOrd(data.qtyOrd ? data.qtyOrd : 0);

           moment.locale(i18n.language);
          // console.log(data.dueDate ? moment(data.dueDate,'DD.MM.YYYY').toDate().getTime() : 'invalid date');           
           setDueDate(data.dueDate ? moment(data.dueDate,'DD.MM.YYYY').toDate().getTime()   : 0);
           setOpenDate(data.openDate ? moment(data.openDate,'DD.MM.YYYY').toDate().getTime()  : null);
           setCloseDate(data.closeDate ? moment(data.closeDate,'DD.MM.YYYY').toDate().getTime()  : null);
           
           
      })
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  
    useEffect(() => {      
      setEntityId(props.entityId);
    }, [props.entityId])

    useEffect(() => {           
      RestService.callAnyApi('project/getProjectSelectList', null).then((data) => { setProjectList(data);}).catch((error) => {});      
      RestService.callAnyApi('workOrder/getWorkOrderRequestTypeOptions', null).then((data) => {
        data.map((item) => {
          item.label = t('workOrder.label.'+item.label);
        });
        
        setWorkOrderRequestTypeList(data);
      }).catch((error) => {});      


      RestService.callAnyApi('workOrder/getWorkOrderStatusOptions', null).then((data) => {
        data.map((item) => {
          item.label = t('workOrder.label.'+item.label);
        });
        
        setWorkOrderStatusList(data);
      }).catch((error) => {}); 
      
      
    }, []);

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=workOrder&id='+props.selectedRecord, null).then(
          (data) => {
            setWorkOrder(data.responseObject);  
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      
    }
    
    const handleChange = (e,elementName) => {
      
      if(workOrder!=null){
          switch(elementName){              
              case "qtyOrd":
                  workOrder.qtyOrd=e.floatValue;    //number     
                  setQtyOrd(e.floatValue);
              break;             
              default:
          }          
      }
  };

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

   
    const save = (url,values) => {
         
  
      if(loadedDocument==null && values.requestType==='O'){
        showError(null,t('general.message.articleMustHaveRequestTypeIorS'));
        return;
      }

      if(loadedDocument==null && values.requestType==='I' && values.projectId===''){
        showError(null,t('general.message.internalOrderMustHaveSelectedProject'));
        return;
      }

      if(loadedDocument!=null && values.requestType!=='O'){
        showError(null,t('general.message.orderMustHaveRequestTypeO'));
        return;
      }
      
     

      workOrder.articleId = loadedArticle ? loadedArticle.id : '';
            
     
      workOrder.orderLineNumber = values.orderLineNumber;
      workOrder.qtyOrd = values.qtyOrd;
    
      workOrder.status = values.status;
      workOrder.orderId = loadedDocument ? loadedDocument.id : '';
      workOrder.orderLineId = orderLineId;
      workOrder.projectId = values.projectId;
      workOrder.requestType = values.requestType;
      workOrder.wrRouteTemplateId = values.wrRouteTemplateId;
      workOrder.description = values.description;
      workOrder.qtyOrd = qtyOrd;

      workOrder.dueDate  = moment(dueDate).format('DD.MM.YYYY');
      
      
      
     
      RestService.callAnyApi(url, workOrder)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
        articleId: workOrder && workOrder.articleId ? workOrder.articleId : '',
        nbr:  workOrder &&  workOrder.nbr ? workOrder.nbr : '',      
        projectId: workOrder && workOrder.projectId ? workOrder.projectId : '',
        requestType: workOrder && workOrder.requestType ? workOrder.requestType : '',        
        status: workOrder && workOrder.status ? workOrder.status : 'N',
        articleName: workOrder && workOrder.article && workOrder.article.name ? workOrder.article.name: '',
        orderName: workOrder && workOrder.document && workOrder.document.orderNbr ? workOrder.document.orderNbr : '',
        wrRouteTemplateId: workOrder && workOrder.wrRouteTemplateId ? workOrder.wrRouteTemplateId : '',
        description: workOrder && workOrder.description ? workOrder.description : ''
        
      },
      validationSchema: Yup.object({
        
        articleName: Yup.string()     
        .nullable()  
        .test(
          'oneOfRequired',
          t('general.message.articleOrOrderRequired'),
          function(item) {
            return (this.parent.articleName || this.parent.orderName);
          
          }
        ),  
        orderName: Yup.string()     
        .nullable()  
        .test(
          'oneOfRequired',
          t('general.message.articleOrOrderRequired'),
          function(item) {
            return (this.parent.articleName || this.parent.orderName);
          }
        ),  
        requestType:  Yup.string().nullable()  
            .required(t('general.message.required')),
       wrRouteTemplateId:  Yup.string().nullable()  
            .required(t('general.message.required')),    
          
      }),
      onSubmit: (values) => {           
          save('workOrder/saveWorkOrder',values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('workOrder.label.workOrder')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                          <div className="row">       
                          
                                        <div className="col-3 col-sm-3 col-lg-3">

                                          
                                              
                                                    <div className="form-group">
                                                      <label>{t('article.label.number')}</label>
                                                      <input type="text" class="form-control" readOnly value='' {...formik.getFieldProps('nbr')} />
                                                    </div>
                                                    
                                              

                                        </div>
                          </div>

                          <div className="row">       
                          
                                <div className="col-3 col-sm-3 col-lg-3">

                                   
                                       
                                            <div className="form-group">
                                              <label>{t('workOrder.label.articleName')}</label>
                                              <input type="text" class="form-control" readOnly onClick={handleOpenArticleList}  {...formik.getFieldProps('articleName')} />
                                            </div>
                                            {formik.touched.articleName && formik.errors.articleName ? (
                                              <div style={{ color: 'red' }}>{formik.errors.articleName}</div>
                                          ) : null} 
                                       

                                </div>


                                <div className="col-2 col-sm-2 col-lg-2">

                                      
                                        <div className="form-group">
                                          <label>{t('document.label.order')}</label>
                                          <input type="text" class="form-control" readOnly onClick={handleOpenOrderList}  {...formik.getFieldProps('orderName')} />
                                        </div>
                                        {formik.touched.orderNbr && formik.errors.orderNbr ? (
                                          <div style={{ color: 'red' }}>{formik.errors.orderNbr}</div>
                                      ) : null} 
                                      

                                </div>

                                <div className="col-1 col-sm-1 col-lg-1">

                                      
                                        <div className="form-group">
                                          <label>{t('workOrder.label.line')}</label>
                                          <input type="text" class="form-control" readOnly   {...formik.getFieldProps('orderLineNumber')} />
                                        </div>
                                        {formik.touched.orderNbr && formik.errors.orderNbr ? (
                                          <div style={{ color: 'red' }}>{formik.errors.orderNbr}</div>
                                      ) : null} 
                                      

                                </div>

                                <div className="col-3 col-sm-3 col-lg-3">
                                <div className="form-group">
                                  <label>{t('attendance.label.project')}</label>                               
                                  <CustomSelect
                                        className='input'
                                        onChange={value=>formik.setFieldValue('projectId',value.value)}
                                        value={formik.values.projectId}
                                        options={projectList}     
                                  />                                
                                </div>
                                {formik.touched.projectId && formik.errors.projectId ? (
                                  <div style={{ color: 'red' }}>{formik.errors.projectId}</div>
                                ) : null} 
                              </div>    


                              <div className="col-3 col-sm-3 col-lg-3">
                                  <div class="form-group">
                                    <label>{t('workOrder.label.requestType')}</label>                               
                                    <CustomSelect
                                          className='input'
                                          onChange={value=>formik.setFieldValue('requestType',value.value)}
                                          value={formik.values.requestType}
                                          options={workOrderRequestTypeList}     
                                    />                                
                                  </div>
                                  {formik.touched.requestType && formik.errors.requestType ? (
                                    <div style={{ color: 'red' }}>{formik.errors.requestType}</div>
                                  ) : null} 
                              </div>                 


                          </div>

                        
                     



                          <div class="row">

                              <div className="col-2 col-sm-2 col-lg-2">
                                  <div class="form-group">
                                    <label>{t('workOrder.label.pcsOrd')}</label>                               
                                    <NumberFormat displayType='input'  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="0"   value={qtyOrd ? qtyOrd : 0} onValueChange={(values)  => {handleChange(values,"qtyOrd")}} />                                                                                  
                                  </div>
                              </div>   

                                <div className="col-2 col-sm-2 col-lg-2" style={selectedRecord ? {} : {display: 'none'}}>
                                  <div class="form-group">
                                    <label>{t('workOrder.label.changeStatus')}</label>                               
                                    <CustomSelect
                                          className='input'
                                          onChange={value=>formik.setFieldValue('status',value.value)}
                                          value={formik.values.status}
                                          options={workOrderStatusList}     
                                    />                                
                                  </div>
                                  {formik.touched.status  && formik.errors.status ? (
                                    <div style={{ color: 'red' }}>{formik.errors.status}</div>
                                  ) : null} 
                              </div>                 
              


                              <div className="col-2 col-sm-2 col-lg-2">
                                <div className="form-group">
                                    <label>{t('workOrder.label.dueDate')}</label>                                                                               
                                        <DatePicker
                                            className='form-control'   
                                            name="dueDate"                                   
                                            selected={dueDate ? dueDate : null}
                                            onChange={(value) => {
                                              setDueDate(new Date(value).getTime())
                                            }}                                            
                                            dateFormat="dd.MM.yyyy" 
                                            required                                                                               
                                        />   
                                         {formik.touched.dueDate  && formik.errors.dueDate ? (
                                    <div style={{ color: 'red' }}>{formik.errors.dueDate}</div>
                                  ) : null}                                                 						
                                </div>
                              </div>   

                              <div className="col-2 col-sm-2 col-lg-2">
                                            <div className="form-group">
                                                <label>{t('workOrder.label.openDate')}</label>                                                                               
                                                    <DatePicker
                                                        className='form-control'                                      
                                                        selected={openDate}
                                                        onChange={(value) => setOpenDate(new Date(value).getTime())}                                            
                                                        dateFormat="dd.MM.yyyy"                                                                                
                                                        disabled={true}                                                                             
                                                    />                                                   						
                                            </div>
                                </div>     
                                
                                <div className="col-2 col-sm-2 col-lg-2">
                                            <div className="form-group">
                                                <label>{t('workOrder.label.closeDate')}</label>                                                                               
                                                    <DatePicker
                                                        className='form-control'                                      
                                                        selected={closeDate}
                                                        onChange={(value) => setCloseDate(new Date(value).getTime())}                                            
                                                        dateFormat="dd.MM.yyyy"   
                                                        disabled={true}                                                                             
                                                    />                                                   						
                                           </div>
                                </div>    

                                 <div className="col-4 col-sm-4 col-lg-4">
                                    <div className="form-group">
                                      <label>{t('workOrder.label.wrRouteTemplate')}</label>                               
                                      <CustomSelect
                                            className='input'
                                            onChange={value=>formik.setFieldValue('wrRouteTemplateId',value.value)}
                                            value={formik.values.wrRouteTemplateId}
                                            options={templateList}     
                                      />                                
                                    </div>
                                    {formik.touched.wrRouteTemplateId && formik.errors.wrRouteTemplateId ? (
                                      <div style={{ color: 'red' }}>{formik.errors.wrRouteTemplateId}</div>
                                    ) : null} 
                                </div>                 
 

                          </div>
                  
                         
                          <div className="row">

                              <div className="col-12 col-sm-12 col-lg-12">
                                  <div className="form-group">
                                      <label>{t('general.label.description')}</label>
                                      <input type="text" class="form-control"  value=""  placeholder={t('general.label.description')} {...formik.getFieldProps('description')} />
                                  </div>
                                  {formik.touched.description && formik.errors.description ? (<div style={{ color: 'red' }}>{formik.errors.description}</div>) : null} 
                              </div>

                          </div>
                           

                    </Modal.Body>
                    <Modal.Footer>                                                  
                          <Button style={selectedRecord  ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>
                          <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 

                <ArticleModalWithDatatable            
                  parentCallback={handleCallback}    
                  modal={showArticleModalWithDatatable}                                
                />

                <DocumentModalWithDatatable         
                    parentCallback={handleCallbackDocumentModalWithDatatable}    
                    modal={showDocumentModalWithDatatable}   
                    entitySubName="order"
                    entitySpecify="ORD-RCT"
                    showSelectEntitySpecify={false}    
                    checkTime={Date.now()}                       
                />
      </>
    );
  };

 export default WorkOrderModal;